import React from "react";
import { Link, MenuItem, Stack, Typography } from "@mui/material";
import { imageIdToUrlFallback } from "../../data";

export interface RecipeMenuItemProps {
    url: string;
    imageId?: number;
    name: string;
}

export default function RecipeMenuItem({ name, url, imageId }: RecipeMenuItemProps) {
    return (
        <MenuItem href={url} component={Link}>
            <Stack direction="row" alignItems="center" spacing="5px">
                <img
                    src={imageIdToUrlFallback("thumb", imageId)}
                    style={{ objectFit: "cover", height: "50px", aspectRatio: 1 }}
                />
                <Typography sx={{ textWrap: "auto" }}>{name}</Typography>
            </Stack>
        </MenuItem>
    );
}
